module.exports = __webpack_public_path__ + "img/register.bf32370e.png";